<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title-logo">
                {{ $t('send') }}
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
            @click.passive="onClickBack()"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                class="img-backkey"> 
            </div>  
        </div> 
        <!-- 시세창 -->
        <div class="price-box">
            <img 
            src="@/assets/price_bg.png"
            class="img-price-box"> 
            <div class="txt-eth-price">{{this.mSymbol}} {{ $t('market_price') }}</div>
            <div class="txt-eth-value" v-show="this.$langUtil.getCurrency() == 'krw'">{{this.mCoinPriceKRW}}</div>
            <div class="txt-eth-value" v-show="this.$langUtil.getCurrency() == 'usd'">{{this.mCoinPriceUSD}}</div>
            <div class="txt-eth-unit" v-show="this.$langUtil.getCurrency() == 'krw'">{{ $t('krw_won') }}</div>
            <div class="txt-eth-unit" v-show="this.$langUtil.getCurrency() == 'usd'">{{ $t('usd') }}</div>
        </div> 
        <!-- 이더로고 -->
        <div class="ether-logo-position">
             <img 
            :src="this.mIconUrl"
            class="img-ether-logo"> 
        </div>   
        <!-- 이더량 -->
        <div class="ether-amount">{{$satoshiUtil.satoshiToMCH(this.mBalance)}} {{this.mSymbol}}</div>   
        <!-- 라인 -->
        <div class="bottom-line"></div>
        <!-- 입금금액 -->
        <div class="amount-box-00"> 
            <img 
            src="@/assets/send_result_bg.png"
            class="img-box">   
            <div class="txt-amount-label">{{ $t('deposit') }}</div>  
            <div class="txt-amount-value">{{this.mSendAmount}} {{this.mSymbol}}</div>        
        </div>
        <!-- 수수료 -->
        <div class="amount-box-01"> 
            <img 
            src="@/assets/send_result_bg.png"
            class="img-box">      
            <div class="txt-amount-label">{{ $t('fee') }}</div> 
            <div class="txt-amount-value">{{ this.mSendFee }}  {{this.mSymbol}}</div>                    
        </div> 
        <!-- 지갑주소 -->
        <div class="amount-box-02"> 
            <img 
            src="@/assets/send_result_bg.png"
            class="img-box-01"> 
            <div class="txt-amount-label">{{ $t('address_wallet') }}</div>    
            <div class="txt-amount-value">{{this.mSendAddress}}</div>                      
        </div>  
        <!-- 전송 후 잔액 -->
        <div class="amount-box-03"> 
            <img 
            src="@/assets/send_result_bg.png"
            class="img-box"> 
            <div class="txt-amount-label">{{ $t('after_balance') }}</div>  
            <div class="txt-amount-value">{{ this.mAfterBalance }}  {{this.mSymbol}}</div>                        
        </div>  
        <!-- 보내기 -->
        <div class="btn-confirm-postion"
        @click.passive="onClickSend()"
        v-ripple="{ center: true, class: `teal--text`  }"> 
            <div class="txt-center-confirm">{{ $t('send') }}</div>
        </div>
        <!-- 로딩바 -->
        <div class="loading-bar-postion" v-show="mShowLoading">
            <v-progress-circular
            indeterminate
            color="red"
            ></v-progress-circular>
        </div>
        <!-- 패스워드 입력창 띄우기 -->
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <Password />
        </v-dialog>
    </v-app>
</template>
<script>
import axios from 'axios';
import Password from '@/views/Password';
export default {
    created() {
        let payload = this.$route.query.payload;
        let decrypto = this.$cryptoUtil.decrptoMessage(payload);
        let json = JSON.parse(JSON.parse(decrypto));
        this.mMno = json.mno;
        this.mPasswd = json.passwd;
        this.mCoinType = json.coin_type;
        this.mSendAmount = json.send_amount;
        this.mSendAddress = json.send_address;
        this.mCoinPriceKRW = json.coin_price_krw;
        this.mCoinPriceUSD = json.coin_price_usd;
        this.mBalance = json.balance;
        this.mSymbol = json.symbol;
        this.mSymbol = this.mSymbol.toUpperCase();
        this.mSendFee = json.send_fee;
        this.mLoginKey = json.login_key;
        this.mIconUrl = json.icon_url;
        this.mAfterBalance = ( this.$satoshiUtil.satoshiToMCHNumber(this.mBalance) - Number(this.mSendAmount) - Number(this.mSendFee) ).toFixed(8);
        this.$EventBus.$on('summit_passwd', (result) => {
                this.dialog = false;
                let sha512Pass = this.$cryptoUtil.sha256Crypto(result);
                this.sendCoin(sha512Pass);
            });
        this.$EventBus.$on('close_passwd', (result) => {
                this.dialog = false;
            });
    },
    destroyed() {
        console.log("destroyed");
        this.$EventBus.$off('summit_passwd');
        this.$EventBus.$off('close_passwd');
    },
    components: {
        Password,
    },
    data: () => ({
        mMno : "",
        mPasswd : "",
        mCoinType : "",
        mShowLoading : false,
        mBalance : "",
        mAddress : "",
        mSendAmount : "",
        mSendAddress : "",
        mSendFee : "",
        dialog: false,
        mLoginKey : "",
        mCoinPriceKRW : "",
        mCoinPriceUSD : "",
    }),
    methods : {
        onClickBack : function() {
            this.$router.go(-2);
        },
        onClickSend : function() {
            if(this.mAfterBalance < 0) {
                alert(this.$t('no_balance'))
                return;
            }
            this.dialog = true;
        },
        sendCoin : function(passwd) {
            console.log("sendCoin");
            let payload = {};
            payload.cmd = "send-coin";
            payload.mno = this.mMno;
            payload.coin_type = this.mCoinType;
            payload.dest_address = this.mSendAddress;
            payload.amount = this.$satoshiUtil.mchToSatosi(this.mSendAmount);
            payload.login_key = this.mLoginKey; 
            payload.passwd = passwd;
            this.mShowLoading = true;
            console.log("" + JSON.stringify(payload));
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log("" + JSON.stringify(response) );
                this.mShowLoading = false;
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K")); 
                if(serverResponse.result == "1") { // 성공
                    this.$router.go(-2);
                } else if(serverResponse.result == "2") { // 존재하지 않는 지갑주소
                    alert( this.$t('no_exist_address'));
                } else if(serverResponse.result == "3") { // 코인 부족한 경우
                    alert(this.$t('no_coin_balance'));
                } else if(serverResponse.result == "4") { // amount 값 오류
                    alert(this.$t('error_amount'));
                } else if(serverResponse.result == "5") { // pending 상태일때
                    alert(this.$t('retry_complete') );
                } else if(serverResponse.result == "6") { // 같은지갑으로 전송불가
                    alert(this.$t('same_address'));
                } else if(serverResponse.result == "7") { // 패스워드가 틀립니다.
                    alert(this.$t('error_password'));
                } else if(serverResponse.result == "8") { // 마스터지갑 잔액부족
                    alert(this.$t('wrong_login_info'));
                } else if(serverResponse.result == "9") { // 마스터지갑 잔액부족
                    alert(this.$t('no_master_balance') );
                } else {
                    alert(serverResponse.message);
                }
            })
            .catch( ()=>{} );
        }
    }
}
</script>
<style scoped>
  * {
      margin: 0;
      font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
      font-weight: 300;
      padding: 0;
  }
  html, body {
    height: 100vh;
    width: 100vw;
  }
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
    height: 13.24vw;
    width: 100vw;    
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-title-logo {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;
}
.img-title-logo {
    height: 5.925926vw;
    width: 37.407vw;
}
.price-box {
    position: absolute;
    top: 15.37vw; 
    left: 5.6vw;
    height: 8.148vw;
    width: 88.9vw;     
}
.img-price-box {
    height: 8.148vw;
    width: 88.9vw; 
}
.txt-eth-price {
    position: absolute;
    top: 50%; 
    left: 5.5vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-value {
    position: absolute;
    top: 50%; 
    right: 14vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-unit {
    position: absolute;
    top: 50%; 
    right: 6.2vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.ether-logo-position {
    position: absolute;
    top: 28.148vw; 
    left: 47vw;    
}
.img-ether-logo {
    width: auto;    
    height: 8.333vw;  
}
.ether-amount {
    position: absolute;
    top: 37.96296vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    font-family: NanumBarunGothicOTF;
    font-size: 5.092593vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;        
}
.btn-receive {
    position: absolute;
    top: 47.7777vw; 
    left: 25.6vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.btn-send {
    position: absolute;
    top: 47.7777vw; 
    left: 43.7vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.btn-convert {
    position: absolute;
    top: 47.7777vw; 
    left: 61.9vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.img-center-icon {
    position: absolute;
    top: 50%; 
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);       
}
.txt-receive-send {
    position: absolute;
    top: 110%; 
    left: 0px;
    width: 100%;
    text-align: center;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #757c7e;   
}
.bottom-line {
    position: absolute;
    top: 47.77778vw; 
    left: 0vw;    
    width: 100vw;
    height: 5px;
    background-color: #f3f6fb;  
}
.txt-history {
    position: absolute;
    top: 74.81481vw; 
    left: 5.8vw;  
    width: 62px;
    height: 20px;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
    pointer-events: none; 
}
.img-period {
    width: 100%;
    height: 7.777vw;
}
.input-period {
    position: absolute;
    top: 81.85185vw; 
    left: 5.6vw; 
    right: 5.6vw;
}
.qrcode-box {
    position: absolute;
    top: 57.407vw; 
    left: 26vw; 
    width: 52.22vw;
    height: 52.22vw;     
    background-color: gray;  
}
.txt-qrcdoe {
    position: absolute;
    top: 111.11vw; 
    left: 0vw;
    width: 100vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center; 
    color:#231815;
    pointer-events: none; 
}
.txt-eth-address {
    position: absolute;
    top: 123.37vw; 
    left: 6.2vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
    pointer-events: none; 
}
.txt-address-bg {
    position: absolute;
    top: 127.963vw; 
    left: 5.6vw; 
    pointer-events: none; 
}
.img-address-bg {
    width: 88.9vw;
    height: 7.407407vw;
}
.btn-copy-address {
    position: absolute;
    top: 143.5185vw; 
    left: 43.148vw;  
}
.img-copy-address {
    width: 13.7037vw;
    height: 13.7037vw;
}
.txt-copy-address {
    position: absolute;
    top: 159.6296vw; 
    left: 50%;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #757c7e; 
    transform: translate(-50%, 0%);  
    pointer-events: none;         
}
.amount-input-line {
    position: absolute;
    top: 62.2222vw; 
    left: 10.2vw;  
    width: 79.62963vw;
    height: 1px;
    background-color: #757c7e;
}
.address-input-line {
    position: absolute;
    top: 76.111vw; 
    left: 10.2vw;  
    width: 79.62963vw;
    height: 1px;
    background-color: #757c7e;
}
.txt-amount-unit {
    position: absolute;
    top: 56.2963vw; 
    right: 10.6vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 4.166vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #626262;
    pointer-events: none; 
}
.btn-delete-icon {
    position: absolute;
    top: 55vw; 
    right: 20.37vw;  
    width: 5vw;
    height: 5vw;    
}
.btn-paste-postion {
    position: absolute;
    top: 69.25926vw; 
    right: 10.4vw; 
}
.img-paste-postion {
    width: 17.03704vw;
    height: 4.4444vw;    
}
.txt-paste {
    position: absolute;
    top: 50%;  
    left: 0px;  
    width: 100%;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;   
    transform: translate(0%, -50%);  
    pointer-events: none;         
}
.btn-qrcode-postion {
    position: absolute;
    top: 77.77778vw; 
    left: 43.1vw;  
}
.img-qrcode-postion {
    width: 13.7037vw;
    height: 13.7037vw;  
}
.txt-qrcode {
    position: absolute;
    top: 91.6666vw; 
    left: 45.6vw;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #757c7e;     
    pointer-events: none;    
}
.btn-confirm-postion {
    position: fixed;
    bottom: 0vw; 
    left: 0vw;
    width: 100vw;
    height: 14.35185vw;   
    background-color: #345993;
}
.txt-center-confirm {
    position: absolute;    
    top: 50%;  
    left: 50%;  
    font-family: NanumBarunGothicOTF;
    font-size: 4.1666vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    transform: translate(-50%, -50%);  
    pointer-events: none; 
}
.amount-box-00 {
    position: absolute;
    top: 52.40741vw; 
    left: 5.6vw;   
}
.amount-box-01 {
    position: absolute;
    top: 62.96296vw; 
    left: 5.6vw;   
}
.amount-box-02 {
    position: absolute;
    top: 73.51852vw; 
    left: 5.6vw;   
}
.amount-box-03 {
    position: absolute;
    top: 88.3333vw; 
    left: 5.6vw;   
}
.img-box {
    width: 88.8888vw;
    height: 7.407407vw; 
}
.img-box-01 {
    width: 88.8888vw;
    height: 11.666vw; 
}
.txt-amount-label {
    position: absolute;
    top: 20%; 
    left: 5.2vw;    
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #595757;      
}
.txt-amount-value {
    position: absolute;
    top: 20%; 
    right: 5.2vw;     
    width: 60%;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #595757;  
    word-break:break-all;
}
.loading-bar-postion {
    position: absolute;
    top: 50vh;
    left: 50vw; 
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
}
</style>